"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createLogger = createLogger;
exports.default = void 0;
var _localstorage = require("../localstorage");
const hasLocalStorage = (0, _localstorage.canUseLocalStorage)();
const baseStyles = 'color: white; margin: 5px 0; padding: 6px 0; width: 100%;';
const warnStyles = `${baseStyles} background-color: #e89600;`;
const errorStyles = `${baseStyles} background-color: #e00000;`;
function shouldLog() {
  return hasLocalStorage && window.localStorage.getItem('BHR_DEV_LOGGER') === 'true';
}
function log(type, title, styles, prefix, ...everythingElse) {
  if (shouldLog()) {
    if (prefix !== null) {
      everythingElse = [prefix, ...everythingElse];
    }
    console[type](title, styles, ...everythingElse);
  }
}
function createLogger(prefix) {
  prefix = prefix ? `[${prefix}]` : null;
  return {
    warn(...output) {
      log('warn', '%c BHR DEVELOPMENT WARNING ', warnStyles, prefix, ...output);
    },
    error(...output) {
      log('error', '%c BHR DEVELOPMENT ERROR ', errorStyles, prefix, ...output);
    }
  };
}
var _default = exports.default = createLogger();